import React from 'react';
import PropTypes from 'prop-types';
import { useThemePreferenceContext } from '@stashinvest/ui';
import ErrorBoundary from 'stash/components/error-boundary/ErrorBoundary';
import GlobalToast from 'stash/components/toast/Toast';
import './App.css';

const modes = {
	light: 'light',
	dark: 'dark',
};

function App(props) {
	const { userModePreference } = useThemePreferenceContext();

	return (
		<div className={modes[userModePreference]}>
			<ErrorBoundary>
				{props.children}
				<GlobalToast />
			</ErrorBoundary>
		</div>
	);
}

App.propTypes = {
	children: PropTypes.node.isRequired,
};

export default App;
